import React, { useState } from 'react';
import PublicLayout from '../../components/public/PublicLayout';
import PageHero from '../../components/public/PageHero';
import SuccessBanner from '../../components/public/SuccessBanner';
import { trackEvent } from '../../publicSite/analytics';
import { usePageMeta } from '../../publicSite/usePageMeta';

export default function ContactUpdates() {
  usePageMeta('Sign Up for Updates | School of Shem', 'Stay informed on upcoming cohorts and announcements.');
  const [form, setForm] = useState({ email: '', phone: '', interests: [] });
  const [success, setSuccess] = useState(false);

  const toggleInterest = (tag) => {
    setForm(prev => {
      const exists = prev.interests.includes(tag);
      return {
        ...prev,
        interests: exists ? prev.interests.filter(i => i !== tag) : [...prev.interests, tag]
      };
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const submissions = JSON.parse(localStorage.getItem('shem_updates') || '[]');
    submissions.push({ ...form, submittedAt: new Date().toISOString() });
    localStorage.setItem('shem_updates', JSON.stringify(submissions));
    setSuccess(true);
    trackEvent('updates_submit', { channel: 'public' });
  };

  return (
    <PublicLayout>
      <PageHero
        eyebrow="Stay Connected"
        title="Sign up for updates"
        subtitle="Get cohort announcements, program launches, and community updates."
        image="/images/shem-community-event.jpg"
        imageAlt="The School of SHEM community gathering together"
      />
      <section className="ps-section">
        <div className="ps-section-inner">
          {success && (
            <SuccessBanner
              title="You’re on the list"
              message="We will send you the next cohort updates shortly."
              onClose={() => setSuccess(false)}
            />
          )}
          <form className="ps-form" onSubmit={handleSubmit}>
            <div className="ps-form-grid">
              <input className="ps-input" type="email" placeholder="Email" required value={form.email} onChange={(e) => setForm(prev => ({ ...prev, email: e.target.value }))} />
              <input className="ps-input" placeholder="Phone / WhatsApp" value={form.phone} onChange={(e) => setForm(prev => ({ ...prev, phone: e.target.value }))} />
            </div>
            <div>
              <div style={{ fontWeight: 600, marginBottom: '8px' }}>Interests</div>
              <div className="ps-card-grid">
                {['Wealth', 'Leadership', 'Family', 'Faith', 'Youth', 'Community'].map(tag => (
                  <button
                    key={tag}
                    type="button"
                    className={`btn btn-outline btn-sm ${form.interests.includes(tag) ? 'is-selected' : ''}`}
                    onClick={() => toggleInterest(tag)}
                  >
                    {tag}
                  </button>
                ))}
              </div>
            </div>
            <button className="btn btn-gold" type="submit">Submit</button>
          </form>
        </div>
      </section>
    </PublicLayout>
  );
}
